import { makeStyles } from '@mui/styles';
import { colors, fontWeight } from '../../../packages';

export const sxStyles = {
  pageWrapper: {
    width: '100%',
    minHeight: 'calc(100vh - 64px)',
    backgroundColor: colors.neutral50,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    width: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    marginBottom: 3,
  },
  totalCount: {
    fontSize: '14px',
    color: colors.neutral900,
    marginLeft: 1.5,
    fontWeight: fontWeight.SEMI_BOLD,
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '24px',
    padding: '4px 12px',
    display: 'inline-flex',
    alignItems: 'center',
  },
  customFiltersContainer: {
    borderBottom: `1px solid ${colors.neutral200}`,
    padding: '16px 24px 0',
    position: 'relative',
  },
  filterTabsWrapper: {
    display: 'flex',
    gap: '24px',
    position: 'relative',
    marginLeft: '-24px',
  },
  notReviewedTab: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 0 16px',
    fontSize: '14px',
    cursor: 'pointer',
    position: 'relative',
    paddingLeft: '24px',
    borderBottom: '1px solid transparent',
    marginBottom: '-1px',
    '&:hover': {
      opacity: 0.8,
    },
  },
  reviewedTab: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 0 16px',
    fontSize: '14px',
    cursor: 'pointer',
    position: 'relative',
    borderBottom: '1px solid transparent',
    marginBottom: '-1px',
    '&:hover': {
      opacity: 0.8,
    },
  },
  activeTab: {
    borderBottom: `2px solid ${colors.neutral900}`,
    fontWeight: fontWeight.BOLD,
    '& span': {
      fontWeight: fontWeight.BOLD,
    },
  },
  notActiveTab: {
    '& span': {
      fontWeight: fontWeight.BOLD,
      color: colors.neutral600,
    },
  },
  activeCount: {
    fontWeight: fontWeight.SEMI_BOLD,
    color: colors.neutral700,
  },
  notActiveCount: {
    fontWeight: fontWeight.SEMI_BOLD,
    color: colors.neutral500,
  },
  count: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '24px',
    padding: '4px 12px',
    fontSize: '12px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorContainer: {
    padding: '20px',
    textAlign: 'center',
    color: colors.error,
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateText: {
    paddingLeft: '13px',
  },
  emptyStateContainer: {
    padding: '40px 0',
    textAlign: 'center',
    width: '100%',
  },
  tableContainer: {
    backgroundColor: colors.white,
    borderRadius: 1,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  },
  statusNotReviewed: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '7px',
  },
  statusReviewed: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '8px',
  },
};

export const useStyles = makeStyles({
  title: { fontFamily: 'Source Serif Pro' },
  tableHeader: {
    backgroundColor: colors.neutral50,
    '& th': {
      backgroundColor: colors.neutral50,
    },
  },
  tableCell: {
    '& .MuiTableCell-root': {
      paddingLeft: '16px !important',
    },
  },
  menu: {
    float: 'right',
    right: 20,
    '& svg': {
      width: 16,
    },
  },
  menuItemsWrapper: {
    '& ul': {
      padding: 0,
    },
    '& ul li': {
      padding: '10px 16px',
    },
  },
});
